// src/core/auth/pages/VerifyEmailPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import { EmailVerificationScreen } from './components/EmailVerificationScreen';
import { authApi } from '../api/authApi';

export function VerifyEmailPage() {
  const nav = useNavigate();
  const [loginId, setLoginId] = React.useState('');
  const [resolved, setResolved] = React.useState(null);
  const [err, setErr] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  async function handleResolve() {
    setErr(null);
    setLoading(true);
    try {
      const res = await authApi.resolveLoginId({ loginId });
      setResolved(res);
    } catch (e) {
      setErr(e?.response?.data?.message || e?.message || 'Bulunamadı');
    } finally {
      setLoading(false);
    }
  }

  // resolve olmadıysa loginId sor
  if (!resolved) {
    return (
      <MDBox sx={{ p: 2, maxWidth: 520, mx: 'auto', display: 'grid', gap: 1.5 }}>
        {err && <Alert severity="error">{err}</Alert>}

        <MDInput
          label="Kullanıcı adı veya e-posta"
          value={loginId}
          onChange={(e) => setLoginId(e.target.value)}
          placeholder="kerem.turak veya kerem@mail.com"
          fullWidth
        />

        <MDButton
          variant="gradient"
          color="info"
          onClick={handleResolve}
          disabled={!loginId.trim() || loading}
          fullWidth
        >
          Devam et
        </MDButton>

        <MDButton
          variant="text"
          color="dark"
          onClick={() => nav('/sign-in', { replace: true })}
          fullWidth
        >
          Giriş ekranına dön
        </MDButton>
      </MDBox>
    );
  }

  // resolve olduysa doğrulama ekranı
  return (
    <MDBox sx={{ p: 2, maxWidth: 520, mx: 'auto' }}>
      <EmailVerificationScreen
        email={resolved?.emailMasked || '—'}
        loginId={loginId.trim()}
        onVerify={({ loginId, code }) => authApi.verifyEmail({ loginId, code })}
        onResend={({ loginId }) => authApi.resendVerifyEmail({ loginId })}
        onGoLogin={() => nav('/sign-in', { replace: true })}
      />
    </MDBox>
  );
}
